module.exports = __webpack_public_path__ + "7b8e5e56262661cf483186b403fbf79f.jpg";